/**
 * Returns true when the given URL is the authenticated, membership-gated community or channel
 * image/logo route that requires a JavaScript blob-fetch (cannot be used directly in an <img> src),
 * because Private communities are not resolvable via the anonymous proxy.
 */
export function isProtectedCommunityImageRoute(imageUrl: string | null | undefined): boolean {
    if (!imageUrl) return false;
    const trimmed = imageUrl.trim();
    return /\/api\/application\/participant\/community-hub\/[^/]+\/(?:image|logo)\/content(?:\?.*)?$/.test(trimmed)
        || /\/api\/application\/participant\/community-hub\/[^/]+\/channels\/[^/]+\/logo\/content(?:\?.*)?$/.test(trimmed);
}
